module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_01a.d60bd39d.jpg";